import { useSelector } from "react-redux";
import { CurrentUserState, updateProfile } from "../redux/current-user-slice";
import { AppState } from "../redux/store";
import { useDispatch } from "react-redux";
import { UserProfile } from "@nt-portal/server-sdk";

/**
 * Exposes the current user's profile along with an updater dispatch helper.
 * @returns Tuple containing the profile object and a function to persist changes.
 */
export function useUserProfile() {

    const dispatch = useDispatch<any>();
    const _currentUserState = useSelector<AppState>(state => state.currentUser) as CurrentUserState;
    
    /**
     * Dispatches the provided profile to the redux store.
     * @param profile - Updated user profile payload.
     */
    const update  = (profile: UserProfile) => {

        return dispatch(updateProfile(profile));
    }
    
    return [_currentUserState.profile, update] as const;
}

